//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import getAngularInjector from '@react-bridge/getAngularInjector';
import { CollectionsSettingsService } from '@services/collections-settings-service';

import '@services/collections-settings-service';

interface CollectionsService {
  refreshCollections: () => void;
}

// TODO: PD-245053 - Remove legacy collectionsService and switch to react-query.
export const getCollectionsService = (): CollectionsService => {
  return getAngularInjector().get('CollectionsService');
};

// TODO: PD-247216 - Remove dependency on CollectionsSettingsService after the react migration for collections is complete
export const getCollectionsSettingsService = (): CollectionsSettingsService => {
  return getAngularInjector().get('CollectionsSettingsService');
};
